import { render, staticRenderFns } from "./XiuZheng.vue?vue&type=template&id=4026ac68"
import script from "./XiuZheng.vue?vue&type=script&lang=js"
export * from "./XiuZheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports